import { Stack, Typography, Box } from '@mui/material';
import CodeViewer from 'components/CodeViewer';
import React from 'react';
import { IDPResponse } from 'types/api';

interface ITestResultsProps {
	result: IDPResponse;
}

const TestResults: React.FC<ITestResultsProps> = ({ result }) => (
	<>
		<Stack flexGrow={1} gap={2}>
			<Typography>
				{intl.tr(
					result.samlResponse
						? 'ssoConfig.testPage.response.saml.idp'
						: 'ssoConfig.testPage.response.oidc.idp'
				)}
			</Typography>
			<Box flexGrow={1}>
				<CodeViewer
					content={result?.samlResponse || result?.oidcResponse}
					language={result?.samlResponse ? 'xml' : 'json'}
					maxHeight={500}
				/>
			</Box>
		</Stack>
		<Stack flexGrow={1} gap={2}>
			<Typography>
				{intl.tr(
					result.samlGeneratedUser
						? 'ssoConfig.testPage.response.saml.user'
						: 'ssoConfig.testPage.response.oidc.user'
				)}
			</Typography>
			<Box flexGrow={1}>
				<CodeViewer
					data-testid="json-user-result"
					content={result?.samlGeneratedUser || result?.oidcGeneratedUser}
					language="json"
					maxHeight={500}
				/>
			</Box>
		</Stack>
		<Stack flexGrow={1} gap={2}>
			<Typography>
				{intl.tr(
					result.samlGeneratedRoles
						? 'ssoConfig.testPage.response.saml.roles'
						: 'ssoConfig.testPage.response.oidc.roles'
				)}
			</Typography>
			<Box flexGrow={1}>
				<CodeViewer
					data-testid="json-roles-result"
					content={
						result?.samlGeneratedRoles || result?.oidcGeneratedRoles || '[]'
					}
					language="json"
					maxHeight={500}
				/>
			</Box>
		</Stack>
	</>
);

export default TestResults;
